import { render, staticRenderFns } from "./PrimerPage.vue?vue&type=template&id=9293f0da&scoped=true"
import script from "./PrimerPage.vue?vue&type=script&lang=js"
export * from "./PrimerPage.vue?vue&type=script&lang=js"
import style0 from "./PrimerPage.vue?vue&type=style&index=0&id=9293f0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9293f0da",
  null
  
)

export default component.exports